import { render, staticRenderFns } from "./ConsultaSaldosContables.vue?vue&type=template&id=5a2e70f6"
import script from "./ConsultaSaldosContables.vue?vue&type=script&lang=js"
export * from "./ConsultaSaldosContables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports